import { authFetch } from './AuthService';

export async function getCollection() {
  const res = await authFetch('/api/collection');
  if (!res.ok) throw new Error('Failed to load collection');
  const data = await res.json();
  return data.collection;
}

export async function updateCard(cardId, variant, quantity) {
  const res = await authFetch('/api/collection/card', {
    method: 'PUT',
    body: JSON.stringify({ cardId, variant, quantity })
  });
  if (!res.ok) throw new Error('Failed to update card');
  return res.json();
}

export async function importCollection(data) {
  const res = await authFetch('/api/collection/import', {
    method: 'PUT',
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error('Import failed');
  return res.json();
}

export async function exportCollection() {
  const res = await authFetch('/api/collection/export');
  if (!res.ok) throw new Error('Export failed');
  return res.json();
}

export async function getPackStats() {
  const res = await authFetch('/api/pack-stats');
  if (!res.ok) throw new Error('Failed to load pack stats');
  return res.json();
}

export async function savePackStats(stats) {
  const res = await authFetch('/api/pack-stats', {
    method: 'PUT',
    body: JSON.stringify(stats)
  });
  if (!res.ok) throw new Error('Failed to save pack stats');
  return res.json();
}

export async function getPokedexBinder() {
  const res = await authFetch('/api/pokedex-binder');
  if (!res.ok) throw new Error('Failed to load pokedex binder');
  const data = await res.json();
  return data.binder;
}

export async function savePokedexSlot(dexNumber, snapshot) {
  const res = await authFetch(`/api/pokedex-binder/${dexNumber}`, {
    method: 'PUT',
    body: JSON.stringify(snapshot)
  });
  if (!res.ok) throw new Error('Failed to save pokedex slot');
  return res.json();
}

export async function removePokedexSlot(dexNumber) {
  const res = await authFetch(`/api/pokedex-binder/${dexNumber}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Failed to remove pokedex slot');
  return res.json();
}

export async function getSettings() {
  const res = await authFetch('/api/settings');
  if (!res.ok) throw new Error('Failed to load settings');
  return res.json();
}

export async function saveSettings(settings) {
  const res = await authFetch('/api/settings', {
    method: 'PUT',
    body: JSON.stringify(settings)
  });
  if (!res.ok) throw new Error('Failed to save settings');
  return res.json();
}
